var map = {
	"./pages/DashboardCampign/TopUp/TopUp.jsx": [
		8242,
		8242
	],
	"pages/DashboardCampign/TopUp/TopUp.jsx": [
		8242,
		8242
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85484;
module.exports = webpackAsyncContext;